import { Factory } from "@/data/dao/Factory";
import { SubscriptionDao } from "@/data/dao/service/SubscriptionDao";
import type { ISubscription } from "@/data/model/Subscription";

import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { SubscriptionForm } from "@/portal/forms/SubscriptionForm";

export class SubscriptionController extends BaseTabbedController<ISubscription> {
    private subscriptionForm: SubscriptionForm;

    constructor(element: JQuery) {
        super(element, Factory.getInstance(SubscriptionDao));

        this.subscriptionForm = new SubscriptionForm(this.formContentByTabName("subscriptionedit"));
        this.registerModelForm(this.subscriptionForm);

        this.onActivateTab = () => {};
    }

    protected onModelLoaded(m?: ISubscription) {
        this.subscriptionForm.setData(m);
    }
}
